// extracted by mini-css-extract-plugin
export default {"headerWrapper":"HeaderSection_headerWrapper__1zVHL","headerSection":"HeaderSection_headerSection__0UQ6w","cardsRow":"HeaderSection_cardsRow__URrHW"};